<template>
  <v-form :ref="setFormRef" @submit.prevent="add">
    <strong>Add</strong>
    <AppRow>
      <TextField label="Code" v-model="coupon.code" :rules=[required] />
      <v-slider label="%" v-model="coupon.discount" step="1" thumb-label="always" />
    </AppRow>
    <AppRow>
      <div>
        <AppCheckbox label="Partner" v-model="hasPartner" />
        <template v-if="coupon.partner">
          <TextField label="Partner Name" v-model="coupon.partner.name" :rules=[required] />
          <EmailField label="Partner Email" v-model="coupon.partner.email" :rules=[required] />
        </template>
      </div>
      <div>
        <AppCheckbox label="Expiry" v-model="hasExpiry" />
        <template v-if="coupon.expiry">
          <DatePicker label="Expiry Date" v-model="coupon.expiry" :rules=[required] />
        </template>
      </div>
    </AppRow>
    <AppBtn type="submit" :loading="loading" primary>
      Add
    </AppBtn>
  </v-form>
</template>

<script setup lang="ts">
import { couponFactory } from '~/factories/mini-factories';
import { getDaysAheadIso } from '~/helpers/date';
import { addCoupon } from '~/helpers/http';
import type { Coupon } from '~/types';

const { setFormRef, loading, submit, reset } = useForm();
const { required } = useValidation();

const coupon = reactive<Coupon>(couponFactory(''));

const hasPartner = ref(false);
watch(hasPartner, hasPartner => {
  coupon.partner = hasPartner ? { name: '', email: '' } : undefined;
});

const hasExpiry = ref(false);
watch(hasExpiry, hasExpiry => {
  coupon.expiry = hasExpiry ? getDaysAheadIso(14) : undefined;
});

const emit = defineEmits(['added']);
function add() {
  submit(async () => {
    const response = await addCoupon(coupon);
    if (!response.success) throw new Error('Failed to add coupon');
    emit('added');
    reset();
  }, { successMsg: `Coupon ${coupon.code} added` });
}
</script>